module.exports = __webpack_public_path__ + "static/media/hifi.d5c9e6f4.svg";